export default "__VITE_ASSET__ufEHw6ln__"